import React, { useState } from 'react';
import { Phone, Menu, X, Settings } from 'lucide-react';
import { mockData } from '../mock';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="bg-white/95 backdrop-blur-md border-b border-[#E4E1D8] sticky top-0 z-50 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <div className="flex items-center">
            <a href="/" className="flex items-center">
              <img 
                src="https://customer-assets.emergentagent.com/job_disability-care-hub/artifacts/kyxcujac_SmileAPal-half-logo.png" 
                alt="Smile a Pal Logo" 
                className="h-14 w-auto"
              />
            </a>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            {mockData.navigation.map((item) => (
              <a
                key={item.path}
                href={item.path}
                target={item.path.startsWith('http') ? '_blank' : undefined}
                rel={item.path.startsWith('http') ? 'noopener noreferrer' : undefined}
                className="text-[#2C2C2A] hover:text-[#0F6E56] transition-colors font-medium text-[17px]"
              >
                {item.label}
              </a>
            ))}
          </nav>

          {/* CTA Buttons */}
          <div className="hidden lg:flex items-center space-x-4">
            <a
              href={`tel:${mockData.companyInfo.phone.replace(/[^0-9]/g, '')}`}
              className="flex items-center space-x-2 text-[#0F6E56] hover:text-[#5DCAA5] transition-colors font-medium text-[17px]"
            >
              <Phone className="w-4 h-4" />
              <span>{mockData.companyInfo.phone}</span>
            </a>
            <a
              href="#contact"
              className="px-6 py-2.5 bg-[#0F6E56] text-white rounded-full hover:bg-[#0d5c48] transition-all duration-300 font-medium shadow-md hover:shadow-lg text-[17px]"
            >
              Get Started
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden text-[#2C2C2A] p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="lg:hidden bg-white/95 backdrop-blur-md border-t border-[#E4E1D8]">
          <div className="px-4 py-6 space-y-4">
            {mockData.navigation.map((item) => (
              <a
                key={item.path}
                href={item.path}
                target={item.path.startsWith('http') ? '_blank' : undefined}
                rel={item.path.startsWith('http') ? 'noopener noreferrer' : undefined}
                className="block py-2 text-[#2C2C2A] hover:text-[#0F6E56] font-medium"
              >
                {item.label}
              </a>
            ))}
            <div className="pt-4 space-y-3 border-t border-[#E4E1D8]">
              <a
                href={`tel:${mockData.companyInfo.phone.replace(/[^0-9]/g, '')}`}
                className="flex items-center justify-center space-x-2 w-full px-5 py-3 border-2 border-[#0F6E56] text-[#0F6E56] rounded-full hover:bg-[#0F6E56] hover:text-white transition-colors font-medium"
              >
                <Phone className="w-4 h-4" />
                <span>{mockData.companyInfo.phone}</span>
              </a>
              <a
                href="#contact"
                className="flex items-center justify-center w-full px-6 py-3 bg-[#0F6E56] text-white rounded-full hover:bg-[#0d5c48] transition-colors font-medium"
              >
                Get Started
              </a>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;